import { addDays, startOfDay, subDays, subWeeks } from 'date-fns'

import { DatepickerValueType } from '@procsea/design-system'

import { OrderType } from 'src/types'

import { OrderTypeSelectorValue } from '../OrderTypeSelector/OrderTypeSelector'

export interface ShippingDateRange {
  fromShippingDate?: Date
  toShippingDate?: Date
}

type GetFormattedRangeProps = {
  from?: Date
  to?: Date
}

export const getDateFromType = (type: OrderTypeSelectorValue) => {
  const now = startOfDay(new Date())

  const dateRangeByType: Record<OrderTypeSelectorValue, ShippingDateRange> = {
    [OrderType.TODAY]: { fromShippingDate: undefined, toShippingDate: undefined },
    [OrderType.FUTURE]: {
      fromShippingDate: addDays(now, 1),
      toShippingDate: undefined,
    },
    [OrderType.PAST]: {
      fromShippingDate: subWeeks(now, 4),
      toShippingDate: subDays(now, 1),
    },
  }

  return dateRangeByType[type]
}

export const getFormattedRange = ({
  from,
  to,
}: GetFormattedRangeProps): DatepickerValueType<true> | undefined =>
  !!from || !!to ? [from ?? null, to ?? null] : undefined
